import { AppState } from 'store/types'

export const getStems = (state: AppState) => state.upload.stems
